import { useFormContext, useWatch } from 'react-hook-form'
import { SelectComponent } from '../../../../components/Form/Select'
import { useEffect } from 'react'

export function TipoDePessoa() {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext()

  const cnpjCpf = useWatch({ name: 'cnpjCpf' })

  const replacedCnpjCpf = cnpjCpf?.replace(/\D/g, '')

  useEffect(() => {
    if (replacedCnpjCpf?.length === 14) {
      setValue('personType', { value: 'Pessoa Jurídica', label: 'Pessoa Jurídica' })
    }

    if (replacedCnpjCpf?.length === 11) {
      setValue('personType', { value: 'Pessoa Física', label: 'Pessoa Física' })
    }

    if (replacedCnpjCpf?.length === 0) {
      setValue('personType', { value: '', label: '' })
    }
  }, [replacedCnpjCpf, setValue])

  return (
    <SelectComponent
      width="100%"
      label="Tipo de Pessoa"
      control={control}
      name="personType"
      options={[
        { value: 'Pessoa Jurídica', label: 'Pessoa Jurídica' },
        { value: 'Pessoa Física', label: 'Pessoa Física' },
      ]}
      error={errors.personType}
      isDisabled
    />
  )
}
